module.exports = __webpack_public_path__ + "img/bluecalendar.a9d7289b.svg";